// extracted by mini-css-extract-plugin
module.exports = {"figure":"dato-image_figure__0XJ9e","figure--background":"dato-image_figure--background__so6EP"};